// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrandsHome {
    display: flex;
    height: 88px;
    justify-content: space-around;
    align-items: center;
    align-self: stretch;
    /* padding-top: 100px; */
    padding-top: 136px;
    mix-blend-mode: multiply;
    filter: opacity(1);
}

.payment-logos {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 20px 0;
}

.payment-logos img {
    height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/css/BrandsHome.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".BrandsHome {\n    display: flex;\n    height: 88px;\n    justify-content: space-around;\n    align-items: center;\n    align-self: stretch;\n    /* padding-top: 100px; */\n    padding-top: 136px;\n    mix-blend-mode: multiply;\n    filter: opacity(1);\n}\n\n.payment-logos {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin: 20px 0;\n}\n\n.payment-logos img {\n    height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
